interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    }
  }

  return (
    <nav className="mt-6 flex items-center justify-center gap-2 flex-wrap">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="h-9 px-3 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 whitespace-nowrap cursor-pointer hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
      >
        上一页
      </button>
      {pages.map((page, index) => {
        const prev = pages[index - 1];
        const showEllipsis = prev !== undefined && page - prev > 1;
        return (
          <span key={page} className="flex items-center gap-2">
            {showEllipsis && <span className="text-foreground-400 text-sm">…</span>}
            <button
              type="button"
              onClick={() => onChange(page)}
              className={`w-9 h-9 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors ${
                page === current
                  ? 'bg-primary-500 text-secondary-950 font-medium'
                  : 'border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300'
              }`}
            >
              {page}
            </button>
          </span>
        );
      })}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="h-9 px-3 rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 whitespace-nowrap cursor-pointer hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
      >
        下一页
      </button>
    </nav>
  );
}